import Vue from 'vue';
// eslint-disable-next-line
import vueCustomElement from 'vue-custom-element';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ContactFilter from './components/ContactFilter.vue';

library.add(faLink, faLinkedin);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;

// Register your component
Vue.customElement('contact-filter', ContactFilter, {
  // Additional Options: https://github.com/karol-f/vue-custom-element#options
  shadow: false,
});
